import { Refinement } from 'lib/Refinement/types'

import CustomAddonsRefinementList from './CustomAddonsRefinementList'

export const KEY = 'publicFilters.addons'

export const addonsFilterRefinement: Refinement = {
  getQueryParamValue: ({ refinementList }) =>
    refinementList?.[KEY] && {
      addons: refinementList[KEY].join('_'),
    },
  getStateValue: ({ addons }) =>
    addons && {
      refinementList: {
        [KEY]: (addons as string).split('_'),
      },
    },
}

const AddonsFilter = (): JSX.Element => (
  <CustomAddonsRefinementList attribute={KEY} />
)

export default AddonsFilter
